import type { RouteLocationAsRelativeGeneric, RouteLocationNormalized } from 'vue-router'

export function useValidateParamGuard(
  paramKey: string,
  checkFn: (id: string) => Promise<boolean>,
  notFoundRoute: RouteLocationAsRelativeGeneric = { name: 'not-found' },
) {
  return async function (to: RouteLocationNormalized): Promise<boolean | RouteLocationAsRelativeGeneric> {
    const paramValue = to.params[paramKey]

    if (!paramValue || typeof paramValue !== 'string') {
      return notFoundRoute
    }

    const isValid = await checkFn(paramValue)

    return isValid ? true : notFoundRoute
  }
}
